/**
 * CarPoolsList
 */

export default class CarPoolsList {

    // constructor
    constructor(selector) {
        this.$plugin = $(selector);
        let $plugin = this.$plugin;
        if ($plugin.length === 0) {
            return false;
        }
        let vm = this;

        // on status change
        $plugin.on('change', '[data-tncp-carpoolslist="changeStatus"]', function() {
            $plugin.find('[data-tncp-carpoolslist="Spinner"]').show();

            let $checkbox = $(this);
            var changeStatusUrl;

            if ($checkbox.is(':checked')) {
                changeStatusUrl = $checkbox.attr('data-tncp-carpoolslist-activate-xhr');
            } else {
                changeStatusUrl = $checkbox.attr('data-tncp-carpoolslist-deactivate-xhr');
            }

            vm.request = window.xhrRequest({
                url: changeStatusUrl,
                method: 'GET',
            });
            vm.request.then((response) => {
                let vm = this;

                if ($plugin.length > 0) {
                    let xhrPath = $plugin.data('tncp-plugin-reload');

                    vm.request = window.xhrRequest({
                        url: xhrPath
                    }).then((response) => {
                        $plugin.html(response.data.content);
                        
                        $('.js-popup-link--inline').magnificPopup({
                            type: 'inline',
                            midClick: true
                        });
                    });
                }
            });
        });
    }
}
